import axios from "axios";

const BASE_URL = process.env.REACT_APP_USER_DOCUMENTATION_SERVICE;

export interface GetUserDocumentationPostsRequest {
  pageIndex: number;
  pageSize: number;
  query: string;
}

export function getUserDocumentationPosts(request: GetUserDocumentationPostsRequest) {
  return axios.get(
    `${BASE_URL}/get-posts/${request.pageSize}/${request.pageIndex}${request.query}`
  );
}

export function getUserDocumentationPostsCount(sinceDate: Date = null) {
  const since = sinceDate ? sinceDate.toISOString().replace("Z", "") : "";
  return axios.get(`${BASE_URL}/count/posts?since=${since}`);
}

/**
 * Replaces the search keywords on a post.
 *
 * Keywords have their own endpoint rather than travelling with a post edit:
 * the update endpoint requires an exact field count, and it overwrites every
 * field it is given, so sending a post without keywords would erase them.
 */
export function setPostKeywords(postId: number, keywords: string[]) {
  return axios.put(`${BASE_URL}/posts/${postId}/keywords`, { keywords });
}
